import { x } from '@xstyled/styled-components';
import React, { Children } from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { LAYOUT_COMICS } from '../itemIds';
import styled from 'styled-components';

interface Props {
  variant: string;
  gridTemplateColumns?: string | { _: string; lg: string };
}

export type LayoutComicsDefinition = ItemDefinition<
  typeof LAYOUT_COMICS,
  Props
>;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .card-0 {
    grid-area: a;
  }
  .card-1 {
    grid-area: b;
    max-height: 360px;
  }
  .card-2 {
    grid-area: c;
    max-height: 360px;
  }
`;

export class LayoutComics extends Item<typeof LAYOUT_COMICS, Props> {
  protected render({
    variant,
    gridTemplateColumns,
    children
  }: RenderProps<Props>) {
    const childArray = Children.toArray(children);

    if (!gridTemplateColumns) {
      gridTemplateColumns = {
        _: '1fr',
        lg: `repeat(${childArray.length}, 1fr)`
      };
    }

    if (variant === 'double') {
      return (
        <x.div
          w="100%"
          h="100%"
          px={{ _: 'md', md: 'md', lg: 'xl' }}
          py={{ _: 'xxxl', md: 'xl', lg: 'xl' }}
          gap={{ _: 'md', md: 'md', lg: 'xl' }}
          flex="1"
          display="grid"
          gridAutoFlow={{ _: 'row', lg: 'column' }}
          gridTemplateColumns={gridTemplateColumns}
          gridTemplateRows={{
            _: `repeat(${childArray.length}, auto)`,
            lg: '1fr'
          }}
        >
          {childArray.map((c, i) => (
            <x.div
              margin={{
                _: 'auto 0',
                md: `${i % 2 ? 'auto 0 auto 200px' : 'auto 200px auto 0'}`,
                lg: 'auto 0'
              }}
              key={i}
            >
              {c}
            </x.div>
          ))}
        </x.div>
      );
    } else {
      return (
        <Wrapper>
          <x.div
            w="100%"
            h="fit-content"
            maxWidth="1300px"
            px={{ _: 'md', md: 'md', lg: 'xl' }}
            py={{ _: 'xxxl', md: 'xl', lg: 'xl' }}
            gap={{ _: 'md', md: 'md', lg: 'xl' }}
            flex="1"
            display="grid"
            gridTemplateColumns={'1fr 1fr 1fr'}
            gridTemplateRows={{
              _: `repeat(${childArray.length}, auto)`,
              lg: '0.8fr 0.8fr'
            }}
            gridTemplateAreas={{
              _: `
                'a a a'
                'a a a'
                'b b b'
                'c c c'
              `,
              md: `
                'a a b b'
                'a a c c'
              `
            }}
          >
            {childArray.map((c, i) => {
              return (
                <x.div margin={'auto 0'} className={`card-${i}`} key={i}>
                  {c}
                </x.div>
              );
            })}
          </x.div>
        </Wrapper>
      );
    }
  }
}

registry[LAYOUT_COMICS] = LayoutComics;
